import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { IconModule } from '@visurel/iconify-angular';
import { MatDatepickerModule, MatDialogModule } from '@angular/material';
import { MessageDialogComponent } from './message-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    IconModule,
    MatDatepickerModule,
    MatDialogModule
  ],
  declarations: [MessageDialogComponent],
  exports: [MessageDialogComponent],
  entryComponents : [MessageDialogComponent]
})
export class MessageDialogModule {
}
